import React from 'react';
import ReactDOM from 'react-dom';
import Root from './root.component';

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById('root')
);
